import { render, staticRenderFns } from "./MoneyStatus.vue?vue&type=template&id=4aa07698&scoped=true&"
import script from "./MoneyStatus.vue?vue&type=script&lang=js&"
export * from "./MoneyStatus.vue?vue&type=script&lang=js&"
import style0 from "./MoneyStatus.vue?vue&type=style&index=0&id=4aa07698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa07698",
  null
  
)

export default component.exports